import React, { useState } from "react";
import { Button, Form, InputGroup, Toast } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import BeatLoader from "react-spinners/BeatLoader";
// import Toast from "../../Hooks/useToast";

import {
  CustomInput,
  Description,
  SubTitle,
  UnorderedList,
} from "../../Components";
// import styles from "./styles/ChangePassword.module.scss";
// import { useChangeUserPasswordMutation } from "../../Data/services/userApi";
// import { useChangePasswordMutation } from "../../Data/services/settingApi";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import ThemeSpinner from "../../Components/general/ThemeSpinner";
import { useChangePasswordMutation } from "../../store/apis/authApi";
import ThemeInput from "../../Components/input/ThemeInput";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { errorMsg, successMsg } from "../../constants/msgs";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/services/authInfo";
import { EmptyLocalStorage } from "../../utils/helper";

export default function ChangePassword() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const handleDataSubmission = async (userData) => {
    try {
      // Use unwrap() to get the response userData directly
      const response = await changePassword(userData).unwrap();
      // console.log(response);

      if (response.status === 400) {
        errorMsg(response?.data?.errors, "error");
      } else {

        EmptyLocalStorage();
        logout()
        navigate("/");
        successMsg(response?.message, "success");

      }


    } catch (error) {
      // console.log(error);
      errorMsg(error?.data?.message, "error");
    }
  };
  return (
    <div className={"ChangePassword"}>

      <SubTitle text="Change Password" classes="text-white" />
      <Description
        text="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        classes="fs-8 mb-4 text-white"
      />
      <Form onSubmit={handleSubmit(handleDataSubmission)}>
        <div className={"form"}>
          {/* <Description text="Current Password" classes="mb-1 text-white" /> */}
          {/* <Controller
            control={control}
            name="current_password"
            rules={{ required: "Current Password is required." }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <InputGroup>
                <CustomInput
                  placeholder="Current Password"
                  type={showPassword ? "text" : "password"}
                  onChange={onChange}
                />
                <span
                  className="input-after-icon mt-1"
                  onClick={handleShowPassword}
                >
                  {showPassword ? (
                    <FaRegEye color="black" />
                  ) : (
                    <FaRegEyeSlash color="grey" />
                  )}
                </span>
              </InputGroup>
            )}
          /> */}
          <div className="password-input">
            <ThemeInput
              name="current_password"
              control={control}
              errors={errors}
              rules={{
                required: {
                  value: true,
                  message: "Current Password is required.",
                }
              }}
              label="Current Password"
              placeholder="Enter your password"
              type={showPassword ? "text" : "password"}
            // minLength={validation.passwordMin}
            // maxLength={validation.passwordMax}
            />
            <span className="eye-icon" onClick={handleShowPassword}>
              {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
            </span>
          </div>
          <div className="password-input">
            <ThemeInput
              name="new_password"
              control={control}
              errors={errors}
              rules={{
                required: {
                  value: true,
                  message: "New Password is required.",
                }
              }}
              label="New Password"
              placeholder="Enter your password"
              type={showNewPassword ? "text" : "password"}
            // minLength={validation.passwordMin}
            // maxLength={validation.passwordMax}
            />
            <span className="eye-icon" onClick={handleShowNewPassword}>
              {showNewPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
            </span>
          </div>
          <div className="password-input">
            <ThemeInput
              name="confirmed_password"
              control={control}
              errors={errors}
              rules={{
                required: {
                  value: true,
                  message: "Confirmed Password is required.",
                }
              }}
              label="Confirm Password"
              placeholder="Enter your password"
              type={showConfirmPassword ? "text" : "password"}
            // minLength={validation.passwordMin}
            // maxLength={validation.passwordMax}
            />
            <span className="eye-icon" onClick={handleShowConfirmPassword}>
              {showConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
            </span>
          </div>

          <UnorderedList
            lists={[
              "At least 12 characters long but 14 or more is better.",
              "A combination of uppercase letters, lowercase letters, numbers, and symbols.",
            ]}
            classes="fs-6 mt-4 mb-4 text-white"
          />

          <div className={"saveButton"}>
            <Button
              type="submit"
              disabled={isLoading}
              className="btn-solid btn-red w-100 mt-4"
              text="Change Password"
            >
              {isLoading ? <ThemeSpinner /> : "Change Password"}
            </Button>
          </div>
        </div>

      </Form>
    </div>
  );
}
